module.exports = __webpack_public_path__ + "static/media/play-icon.cf1e80ee.svg";